import { Injectable } from '@angular/core';
import { ApiResponse } from '@innovation-os-ng/core/auth';
import { Observable } from 'rxjs';
import { ApiSubscriptionService } from '../services/api-subscription.service';

export interface SubscriptionApiResponse extends ApiResponse {
  enabled: Array<string>;
  available: Array<string>;
  prices: { [moduleName: string]: number };
}

@Injectable({
  providedIn: 'root',
  useClass: ApiSubscriptionService
})
export abstract class SubscriptionService {
  /**
   * GET /subscriptions/modules/${tenant_uri}
   * {
   *   enabled:   [“module_uri_1”, ”module_uri_2”],
   *   available: [“module_uri_1”, ”module_uri_2”, “module_uri_3”]
   * }
   */

  /**
   * Returns an observable-stream of modules with information about
   * all enabled or disabled modules for the given tenant.
   *
   * @param tenantUri The tenant uri specifying the tenant the information is requested for
   */
  public abstract getModuleSubscriptions(tenantUri: string): Observable<Array<string>>;

  /**
   * Returns an observable-stream indicating if the specific module is enabled or disabled
   * for the given tenant and module id.
   *
   * @param tenantUri The tenant uri specifying the tenant the information is requested for
   * @param moduleId The module id to be checked
   */
  public abstract isModuleEnabled(tenantUri: string, moduleId: string): Observable<boolean>;

  /**
   * POST /subscriptions/modules/${tenant_uri}
   * {
   *   enable: [”module_uri_3”],
   *   disable: [“module_uri_2"]
   * }
   */

  /**
   *
   * @param tenantUri
   * @param enable
   * @param disable
   */
  public abstract updateModuleSubscriptions(tenantUri: string, enable: Array<string>, disable: Array<string>): Observable<Array<string>>;
}
